import { render } from "./index.vue?vue&type=template&id=731ff88c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=731ff88c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-731ff88c"],['__file',"src/views/Home/Coupons/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "731ff88c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('731ff88c', __exports__)) {
    console.log('reload')
    api.reload('731ff88c', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=731ff88c&scoped=true", () => {
    console.log('re-render')
    api.rerender('731ff88c', render)
  })

}


export default __exports__